import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { formatIntlCurrency } from 'I18n/utils/formatIntlCurrency';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useState } from 'react';
import { BreezeOveragePricingModelMap } from '../../constants/BreezeIntelligenceConstants';
import { BREEZE_CARD } from '../../constants/tracking/TrackingSources';
import { TalkToSalesFallback } from '../../features/purchaseMotions/components/TalkToSalesFallback';
import { useDisplayedCurrencyCode } from '../../hooks/useCurrencies';
import { useAppSelector } from '../../reducers';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { billingNameKeySelector, productForSkuIdSelector, productSelector } from '../../selectors/ProductsSelectors';
import { queryParamTermSelector } from '../../selectors/QueryParamTermSelectors';
import ErrorBoundary from '../error-boundary/ErrorBoundary';
import { AddOnCardCTA } from './AddOnCardCTA';
import AddOnCardLayoutUI from './AddOnCardLayoutUI';
import { BreezeCardPricing } from './BreezeCardPricing';
import { jsx as _jsx } from "react/jsx-runtime";
export const BreezeCard = ({
  screen,
  skuId
}) => {
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const queryParamTerm = useAppSelector(queryParamTermSelector);
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const currencyCode = useDisplayedCurrencyCode();
  const overagePrice = useAppSelector(state => {
    var _productSelector;
    if (!(product.apiName in BreezeOveragePricingModelMap)) return null;
    const overageApiName = BreezeOveragePricingModelMap[product.apiName];
    const overageSkuId = (_productSelector = productSelector(state, {
      apiName: overageApiName
    })) === null || _productSelector === void 0 ? void 0 : _productSelector.currentSkuId;
    return calculatedPriceSelector(state, {
      productConfigurations: overageSkuId ? [createProductConfig({
        skuId: overageSkuId
      })] : [],
      queryParamTerm,
      displayedCurrencyCode: currencyCode
    }).oneTimeFee.calculatedPrice;
  });
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `${BREEZE_CARD}-${product.apiName}`,
    "data-selenium-id": `${BREEZE_CARD}-${product.apiName}`,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages.products.${billingNameKey}.title`
    }),
    pricing: /*#__PURE__*/_jsx(BreezeCardPricing, {
      productConfigurations: productConfigurations,
      skuId: skuId,
      term: queryParamTerm
    }),
    subtitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.addOns.cards.breezeIntelligence.subtitle"
    }),
    cta: /*#__PURE__*/_jsx(ErrorBoundary, {
      fallback: /*#__PURE__*/_jsx(TalkToSalesFallback, {
        apiName: product.apiName,
        trackingSource: BREEZE_CARD,
        screen: screen
      }),
      children: /*#__PURE__*/_jsx(AddOnCardCTA, {
        skuId: skuId,
        screen: screen,
        trackingSource: BREEZE_CARD,
        term: queryParamTerm,
        selectedQuantity: selectedQuantity,
        productConfigurations: productConfigurations,
        onQuantityChange: setSelectedQuantity
      })
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `pricing-pages.products.${billingNameKey}.paragraph`,
      options: Object.assign({}, overagePrice && {
        price: formatIntlCurrency(overagePrice, {
          currencyCode
        })
      })
    })
  });
};
export default BreezeCard;